"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ISCNQueryClient = void 0;
// eslint-disable-next-line import/no-extraneous-dependencies
const tendermint_rpc_1 = require("@cosmjs/tendermint-rpc");
const stargate_1 = require("@cosmjs/stargate");
const bignumber_js_1 = __importDefault(require("bignumber.js"));
const ISCNQueryExtension_1 = require("./ISCNQueryExtension");
const parsing_1 = require("./parsing");
const constant_1 = require("./constant");
class ISCNQueryClient {
    constructor() {
        this.queryClient = null;
        this.stargateClient = null;
        this.feePerByte = null;
    }
    async connect(rpcURL = constant_1.DEFAULT_RPC_ENDPOINT) {
        const [tendermintClient, stargateClient] = await Promise.all([
            tendermint_rpc_1.Tendermint34Client.connect(rpcURL),
            stargate_1.StargateClient.connect(rpcURL),
        ]);
        const queryClient = stargate_1.QueryClient.withExtensions(tendermintClient, ISCNQueryExtension_1.setupISCNExtension, stargate_1.setupBankExtension);
        this.queryClient = queryClient;
        this.stargateClient = stargateClient;
        return {
            queryClient,
            stargateClient,
        };
    }
    async getQueryClient() {
        let { queryClient } = this;
        if (!queryClient)
            ({ queryClient } = await this.connect());
        return queryClient;
    }
    async getStargateClient() {
        let { stargateClient } = this;
        if (!stargateClient)
            ({ stargateClient } = await this.connect());
        return stargateClient;
    }
    async queryISCNIdsByTx(txId) {
        const stargateClient = await this.getStargateClient();
        const res = await stargateClient.getTx(txId);
        if (res) {
            const parsed = (0, parsing_1.parseISCNTxInfoFromIndexedTx)(res);
            const records = [];
            parsed.tx.body.messages.forEach((m, index) => {
                if (!m || !m.typeUrl.includes('/likechain.iscn'))
                    return;
                const log = parsed.logs[index];
                const event = log.events.find((e) => e.type === 'iscn_record');
                if (!event)
                    return;
                const { attributes } = event;
                const ipldAttr = attributes.find((a) => a.key === 'ipld');
                const ipld = ipldAttr && ipldAttr.value;
                const iscnIdAttr = attributes.find((a) => a.key === 'iscn_id');
                const iscnId = iscnIdAttr && iscnIdAttr.value;
                if (!ipld || !iscnId)
                    return;
                records.push(iscnId);
            });
            return records;
        }
        return [];
    }
    async queryRecordsById(iscnId, fromVersion, toVersion) {
        const queryClient = await this.getQueryClient();
        const res = await queryClient.iscn.recordsById(iscnId, fromVersion, toVersion);
        if (res && res.records) {
            const records = (0, parsing_1.parseISCNTxRecordFromQuery)(res.records);
            return Object.assign(Object.assign({}, res), { records });
        }
        return null;
    }
    async queryRecordsByFingerprint(fingerprint, fromSequence) {
        const queryClient = await this.getQueryClient();
        const res = await queryClient.iscn.recordsByFingerprint(fingerprint, fromSequence);
        if (res && res.records) {
            const records = (0, parsing_1.parseISCNTxRecordFromQuery)(res.records);
            return Object.assign(Object.assign({}, res), { records });
        }
        return null;
    }
    async queryRecordsByOwner(owner, fromSequence) {
        const queryClient = await this.getQueryClient();
        const res = await queryClient.iscn.recordsByOwner(owner, fromSequence);
        if (res && res.records) {
            const records = (0, parsing_1.parseISCNTxRecordFromQuery)(res.records);
            return Object.assign(Object.assign({}, res), { records });
        }
        return null;
    }
    async queryFeePerByte() {
        if (this.feePerByte)
            return this.feePerByte;
        const queryClient = await this.getQueryClient();
        const res = await queryClient.iscn.params();
        if (res && res.params && res.params.feePerByte) {
            const { denom, amount, } = res.params.feePerByte;
            this.feePerByte = {
                denom,
                amount: new bignumber_js_1.default(amount).shiftedBy(-18).toFixed(),
            };
            return this.feePerByte;
        }
        return null;
    }
}
exports.ISCNQueryClient = ISCNQueryClient;
exports.default = ISCNQueryClient;
//# sourceMappingURL=queryClient.js.map